// TODO: rename to "TableMenuItem" and couple to Tables
import React from 'react';
import PropTypes from 'prop-types';

import { MenuItem } from '@material-ui/core';

const ActionMenuItem = React.forwardRef(
  ({ children, onClick, ...props }, ref) => {
    return (
      <MenuItem ref={ref} onClick={onClick} {...props}>
        {children}
      </MenuItem>
    );
  },
);

ActionMenuItem.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
};

ActionMenuItem.defaultProps = {};

export default ActionMenuItem;
